import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Severity } from '@soc/shared';

interface RulesUiState {
  search: string;
  /** null = "All"; otherwise filter the rule list to one severity. */
  severityFilter: Severity | null;
  /** Operator-edited rule param values, keyed by ruleId → paramKey → value. */
  params: Record<string, Record<string, number | string>>;
}

const initialState: RulesUiState = {
  search: '',
  severityFilter: null,
  params: {},
};

const rulesUiSlice = createSlice({
  name: 'rulesUi',
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setSeverityFilter(state, action: PayloadAction<Severity | null>) {
      state.severityFilter = action.payload;
    },
    setRuleParam(
      state,
      action: PayloadAction<{ ruleId: string; key: string; value: number | string }>,
    ) {
      const { ruleId, key, value } = action.payload;
      state.params[ruleId] = { ...state.params[ruleId], [key]: value };
    },
  },
});

export const { setSearch, setSeverityFilter, setRuleParam } = rulesUiSlice.actions;
export default rulesUiSlice.reducer;
